import { render, staticRenderFns } from "./TextareaAutocomplete.vue?vue&type=template&id=a16af3ac&scoped=true&"
import script from "./TextareaAutocomplete.vue?vue&type=script&lang=js&"
export * from "./TextareaAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./TextareaAutocomplete.vue?vue&type=style&index=0&id=a16af3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16af3ac",
  null
  
)

export default component.exports